import React from 'react';
import PropTypes from 'prop-types';

import Button from 'ui/Button';

import { DialogActions } from '@mui/material';

const Actions = ({ onClose, onSubmit, loading, disabled }) => {
  return (
    <DialogActions>
      <Button fullwidth secondary onClick={onClose} disabled={loading}>
        Cancel
      </Button>
      <Button fullwidth primary onClick={onSubmit} disabled={loading || disabled}>
        {loading ? 'Saving...' : 'Save Ticket'}
      </Button>
    </DialogActions>
  );
};

Actions.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default Actions;

